import { ICommitmentData } from 'legacy/lut/services/partner360/commitment/models/apiCommitmentData'

import { STATUS_INFO } from '../enums/StatusInfo'

export const getCommitmentGroupStatusInfo = (items: ICommitmentData[]) => {
  const statuses = items.map((el) => el.CommitmentStatusKey)
  if (statuses.includes(STATUS_INFO.Refused)) {
    return { icon: STATUS_INFO.CloseIcon, color: STATUS_INFO.CloseIconColor }
  } else if (statuses.every((el) => el === STATUS_INFO.Acknowledged)) {
    return { icon: STATUS_INFO.CheckIcon, color: STATUS_INFO.CheckIconColor }
  }

  return { icon: STATUS_INFO.ClockIcon, color: STATUS_INFO.ClockIconColor }
}
